function getUniqueKeyForBomTable(productRow, productProp) {
    // concatenation of  productNum and position current property holds

    let position = Object.keys(productRow).findIndex((property) => {
        return property === productProp
    })
    return productRow.productIDNum.toString() + position
}

export { getUniqueKeyForBomTable }
